// extracted by mini-css-extract-plugin
export default {"updatePasswordContainer":"Rw4H6qVqhPpn3JzWzVo2","passwordForm":"qGyGKKWZ0q0NjQYBg0ab","passwordBox":"auTU1yuKy1vqKb4UdnNL"};